import { FormSettingResponse } from 'src/shared/models/formSettingRespons';
import { PagedResult } from '../models/pagedResult';
import AxiosInstance from './axios/interceptor';

const controller = 'FormSetting';

export const getResCause = () => {
  const endpoint = `${controller}/?formName=member&fieldName=resCause`;
  return AxiosInstance.get<PagedResult<FormSettingResponse>>(endpoint);
};

export const getSex = () => {
  const endpoint = `${controller}/?formName=member&fieldName=sex`;
  return AxiosInstance.get<PagedResult<FormSettingResponse>>(endpoint);
};
